<template>
    <div class="gh-btt" ref="button" @click="backToTop">
        <i class="el-icon-arrow-up gh-btt__icon"></i>
    </div>
</template>

<script>
    import UX from '../../utils/ux';

    export default {
        mounted() {
            new ScrollMagic.Scene({
                offset: 500
            })
                .setClassToggle(this.$refs.button, 'is-active')
                .addTo(this.$root.scrollMagicController);
        },

        methods: {
            backToTop() {
                UX.scrollTo(document.querySelector('html'));
            }
        }
    }
</script>